/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ContactPersonV1Dto } from './ContactPersonV1Dto';
export type ContactPersonToPartnerV1Dto = {
  /**
   * The unique identifier of the entity.
   */
  readonly id: string;
  /**
   * The date when the entity was created.
   */
  readonly createdAt: string;
  /**
   * The date when the entity was modified.
   */
  readonly modifiedAt: string;
  /**
   * The current version of the entity
   */
  version: number;
  /**
   * The uuid of the contact-person linked to this relation. As 8-4-4-4-12 format.
   */
  contactPersonId: string;
  /**
   * The uuid of the partner linked to this relation. As 8-4-4-4-12 format.
   */
  partnerId: string;
  /**
   * Role of the contact person in the partner
   */
  role?: ContactPersonToPartnerV1Dto.role;
  /**
   * Job title of the contact person in the partner
   */
  jobTitle?: string;
  /**
   * Contact person associated with the partner
   */
  contactPerson: ContactPersonV1Dto;
};
export namespace ContactPersonToPartnerV1Dto {
  /**
   * Role of the contact person in the partner
   */
  export enum role {
    OWNER = 'Owner',
    TENANT = 'Tenant',
    PROPERTY_MANAGER = 'PropertyManager',
    FACILITY_MANAGER = 'FacilityManager',
    SERVICE_PROVIDER = 'ServiceProvider',
    OTHER = 'Other',
  }
}
